export const appStyles = {
    activeTheme: 'GREEN_THEME',
    activeDir: 'ltr',
    headerHeight: '80px',
    topBarHeight: '40px',
    sideBarWidth: '375px',
}
export default appStyles